function highlight(regions, isHighlight = true, isSeries = false) {
  regions.selectAll(isSeries ? this.seriesName() : this.nodeName()).classed('highlight', isHighlight).call(isHighlight ? this.highlight : this.dehighlight, this.highlightColor());
}
function highlightRegions(callback) {
  let regions;
  if (!arguments.length) { //모두 
    regions = this.filterRegions();
    highlight.call(this, regions, true);
    if (this.seriesName) highlight.call(this, regions, true, true);
  } else if (callback === null) { //모두 끄기
    regions = this.filterRegions();
    highlight.call(this, regions, false);
    if (this.seriesName) highlight.call(this, regions, false, true);
  } else {
    regions = this.filterRegions(callback);
    highlight.call(this, regions, true);
    if (this.seriesName) highlight.call(this, regions, true, true);
  }
  return regions;
}

export default highlightRegions;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/default/highlightRegions.js